module.exports = __webpack_public_path__ + "static/section-heading-bg-573415239d9b6797e42dffce1ef64bf8.png";